import { render } from "./Home.vue?vue&type=template&id=3521ad70&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=3521ad70&lang=scss&scoped=true"

import exportComponent from "E:\\developYZ\\yzWebsite\\newWebsite\\my-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3521ad70"]])

export default __exports__